module.exports = __webpack_public_path__ + "static/img/PopUp_bg.f9773b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PopUp_bg.png
// module id = x0J+
// module chunks = 1